import type { DeviceModelsState } from './types'

const state = (): DeviceModelsState => ({
  modelsMetaData: {}
})

export default state
